import { ref, reactive } from "vue";

//All 3 are locating in Onboarding.vue
export const pointerRef = ref<HTMLDivElement>();
export const modalBodyRef = ref<HTMLDivElement>();
export const modalContainerRef = ref<HTMLDivElement>();

export const onBoardingTextRef = ref<HTMLDivElement>(); //SideToolBar.vue
export const onBoardingImageRef = ref<HTMLDivElement>(); //SideToolBar.vue
export const onBoardingTextToolRef = ref<HTMLDivElement>(); //TextTool.vue
export const onBoardingSettingsRef = ref<HTMLDivElement>(); //TextTool.vue
export const onBoardingZoomSliderRef = ref<HTMLDivElement>(); //BottomToolBar.vue
export const onBoardingPrintRef = ref<HTMLDivElement>(); //PrintPreviewWrap.vue
export const onBoardingSaveDesignRef = ref<HTMLDivElement>(); //SaveAndLoginWrap.vue
export const onBoardingSaveContinueRef = ref<HTMLDivElement>(); //SaveAndContinueWrap.vue

export const reactiveWithRefText: any = reactive({
  fire: false,
  refElement: onBoardingTextRef,
});

export const reactiveWithRefImage: any = reactive({
  fire: false,
  refElement: onBoardingImageRef,
});

export const reactiveWithRefTextTool: any = reactive({
  fire: false,
  refElement: onBoardingTextToolRef,
});

export const reactiveWithRefSettings: any = reactive({
  fire: false,
  refElement: onBoardingSettingsRef,
});

export const reactiveWithRefZoomSlider: any = reactive({
  fire: false,
  refElement: onBoardingZoomSliderRef,
});

export const reactiveWithRefPrint: any = reactive({
  fire: false,
  refElement: onBoardingPrintRef,
});

export const reactiveWithRefSaveDesign: any = reactive({
  fire: false,
  refElement: onBoardingSaveDesignRef,
});

export const reactiveWithRefSaveContinue: any = reactive({
  fire: false,
  refElement: onBoardingSaveContinueRef,
});
